import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const fileUrl = (fileId) => `${BACKEND_URL}/api/files/${fileId}/download`;

export default API;
